// extracted by css-extract-rspack-plugin
export default {"Container":"FWv0P"};